/* Gentle Beauty — SEO edit: animated accordion + expandable keyword pills. Vanilla, defer. */
(function () {
  'use strict';
  if (window.GBSeoEdit) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  function noMotion() { return reduce.matches || !document.documentElement.classList.contains('gb-animate'); }

  function onEnd(el, cb) {
    var done = false;
    var finish = function (e) {
      if (done || (e && e.target !== el)) return;
      done = true;
      el.removeEventListener('transitionend', finish);
      cb();
    };
    el.addEventListener('transitionend', finish);
    setTimeout(finish, 700);
  }

  /* ---------- Accordion ---------- */
  function openItem(item) {
    var panel = item.querySelector('[data-gb-seo-panel]');
    if (!panel || item.dataset.state === 'opening') return;
    item.classList.remove('is-closing');
    if (noMotion()) { item.open = true; item.dataset.state = ''; return; }
    item.dataset.state = 'opening';
    item.open = true;
    var h = panel.scrollHeight;
    panel.style.height = '0px';
    panel.offsetHeight; // reflow
    panel.classList.add('is-animating');
    panel.style.height = h + 'px';
    onEnd(panel, function () {
      panel.classList.remove('is-animating');
      panel.style.height = '';
      item.dataset.state = '';
    });
  }

  function closeItem(item) {
    var panel = item.querySelector('[data-gb-seo-panel]');
    if (!panel || !item.open || item.dataset.state === 'closing') return;
    if (noMotion()) { item.open = false; item.dataset.state = ''; return; }
    item.dataset.state = 'closing';
    item.classList.add('is-closing');
    panel.style.height = panel.scrollHeight + 'px';
    panel.offsetHeight; // reflow
    panel.classList.add('is-animating');
    panel.style.height = '0px';
    onEnd(panel, function () {
      item.open = false;
      item.classList.remove('is-closing');
      panel.classList.remove('is-animating');
      panel.style.height = '';
      item.dataset.state = '';
    });
  }

  /* ---------- Keyword pills ---------- */
  function togglePills(root, btn) {
    var list = root.querySelector('[data-gb-seo-pills]');
    var label = btn.querySelector('[data-gb-seo-toggle-label]');
    if (!list) return;
    var expanding = !list.classList.contains('is-expanded');
    var setState = function () {
      list.classList.toggle('is-expanded', expanding);
      btn.setAttribute('aria-expanded', expanding ? 'true' : 'false');
      if (label) label.textContent = expanding ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
    };
    if (noMotion()) { setState(); return; }

    var start = list.offsetHeight;
    list.classList.toggle('is-expanded', expanding);
    var end = list.offsetHeight;
    list.classList.toggle('is-expanded', !expanding);
    if (expanding) setState();

    list.style.height = start + 'px';
    list.offsetHeight; // reflow
    list.classList.add('is-animating');
    list.style.height = end + 'px';
    onEnd(list, function () {
      if (!expanding) setState();
      list.classList.remove('is-animating');
      list.style.height = '';
      if (!expanding) {
        var rect = btn.getBoundingClientRect();
        if (rect.top < 0) btn.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    });
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-gb-seo-edit]:not([data-gb-seo-init])');
    Array.prototype.forEach.call(roots, function (root) {
      root.setAttribute('data-gb-seo-init', '');
      var single = root.hasAttribute('data-single-open');

      root.addEventListener('click', function (e) {
        var summary = e.target.closest('.gb-seo-edit__summary');
        if (summary && root.contains(summary)) {
          var item = summary.parentElement;
          e.preventDefault();
          if (item.open && item.dataset.state !== 'opening') {
            closeItem(item);
          } else {
            if (single) {
              Array.prototype.forEach.call(root.querySelectorAll('[data-gb-seo-item][open]'), function (other) {
                if (other !== item) closeItem(other);
              });
            }
            openItem(item);
          }
          return;
        }
        var btn = e.target.closest('[data-gb-seo-toggle]');
        if (btn && root.contains(btn)) togglePills(root, btn);
      });

      var toggle = root.querySelector('[data-gb-seo-toggle]');
      if (toggle) toggle.hidden = false;
    });
  }

  window.GBSeoEdit = { init: init, open: openItem, close: closeItem };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target && e.target.closest && e.target.closest('[data-gb-seo-item]');
    if (item) openItem(item);
  });
})();
